import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

import Colors from '@/views/Colors.vue'
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'
import Logout from '@/views/Logout.vue'
import Projects from '@/views/Projects.vue'
import Project from '@/views/Project.vue'
import Record from '@/views/Record.vue'

import store from '@/store/index.js'

const ifNotAuthenticated = (to, from, next) => {
    if (!store.getters.isAuthenticated) {
        next()
    } else {
        next('/projects')
    }
}

const ifAuthenticated = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        next()
    } else {
        next('/login')
    }
}

export default new Router({
    mode: 'history',
    routes: [{
        path: '/login',
        name: 'login',
        component: Login,
        beforeEnter: ifNotAuthenticated,
    }, {
        path: '/demo',
        name: 'demo',
        redirect: {
            name: 'login',
            params: {
                isDemo: true
            }
        }
    }, {
        path: '/colors',
        name: 'colors',
        component: Colors,
        beforeEnter: ifAuthenticated,
    }, {
        path: '/logout',
        name: 'logout',
        component: Logout,
        beforeEnter: ifAuthenticated,
    }, {
        path: '/projects',
        name: 'projects',
        component: Projects,
        beforeEnter: ifAuthenticated,
    }, {
        path: '/project/:api_key/record/:record_id',
        name: 'record',
        component: Record,
    }, {
        path: '/project/:api_key',
        name: 'project',
        component: Project,
    }, {
        path: '/',
        name: 'home',
        component: Home,
        beforeEnter: ifNotAuthenticated,
    }]
})